import { ReactNode, createContext, useContext, useState } from "react";

export type UserDetails = {
  name: string;
  email: string;
  user_id: string;
  mobile_number: string;
  user_salutation: string;
  user_type: string;
  document_type: string;
  gov_id_number: string;
  office_address: string;
  gov_id_document: string;
  document_certificate: string;
  licence_certificate: string;
  experience_certificate?: string;
  email_status: number;
  mobile_status: number;
  regestration_status: number;
};

const UserRegistrationContext = createContext<
  [UserDetails | null, (user: UserDetails | any) => void]
>([null, (_) => {}]);

export function UserRegistraionContextProvider({
  defaultValue,
  children,
}: {
  children: ReactNode | ReactNode[];
  defaultValue: UserDetails;
}) {
  const returnValue = useState<UserDetails | null>(defaultValue || null);
  return (
    <UserRegistrationContext.Provider value={returnValue}>
      {children}
    </UserRegistrationContext.Provider>
  );
}

export function useUserRegistration() {
  return useContext(UserRegistrationContext)[0];
}

export function useSetUserRegistration() {
  return useContext(UserRegistrationContext)[1];
}
